import { useQuery } from 'hooks/useQuery'

import { fetchCompletionById } from 'utils/queries'

import { Completion } from 'types/completion'

export const useCompletion = (completionId: string | undefined) => {
  return useQuery<Completion | undefined>(['completion', [completionId]], () =>
    completionId ? fetchCompletionById(completionId) : undefined,
  )
}
